"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInstallments = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _typography = require("@creditas-lab/typography");

var _InstallmentsSelector = require("../InstallmentsSelector");

var _hooks = require("../../../hooks");

var _Loader = require("../../Loader");

var _RequestError = require("../RequestError");

var _InvalidCreditError = require("../InvalidCreditError");

var _Stepper = require("../../Stepper");

var _constants = require("../../../constants");

var _services = require("../../../services");

var _useProductInstallments = require("./useProductInstallments");

var _ProductInstallments = require("./ProductInstallments.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  productType: _propTypes.string,
  selectedBy: (0, _propTypes.oneOf)([_constants.OrderBy.MIN, _constants.OrderBy.MAX]),
  onRequestProposalClick: _propTypes.func,
  intendedCredit: _propTypes.number
} : {};
var defaultProps = {
  selectedBy: _constants.OrderBy.MIN
};

var ProductInstallments = function ProductInstallments(_ref) {
  var productType = _ref.productType,
      selectedBy = _ref.selectedBy,
      onRequestProposalClick = _ref.onRequestProposalClick,
      intendedCredit = _ref.intendedCredit,
      props = _objectWithoutProperties(_ref, ["productType", "selectedBy", "onRequestProposalClick", "intendedCredit"]);

  var _ref2 = (0, _hooks.useGetSimulations)(productType, intendedCredit),
      status = _ref2.status,
      error = _ref2.error,
      refetch = _ref2.refetch,
      data = _ref2.data;

  var _ref3 = (0, _useProductInstallments.useProductInstallments)({
    productType: productType,
    selectedBy: selectedBy,
    simulations: data
  }),
      installments = _ref3.installments,
      selectedInstallment = _ref3.selectedInstallment,
      onSelectInstallment = _ref3.onSelectInstallment;

  var _ref4 = (0, _Stepper.useStepper)(),
      goTo = _ref4.goTo;

  var handleEditClick = function handleEditClick() {
    (0, _services.dispatchEditCreditButtonClickEvent)();
    goTo(_constants.Steps.IntendedCredit);
  };

  var simulationLoaded = status === _hooks.GetSimulationStatuses.SUCCESS && selectedInstallment;
  return (0, _core.jsx)(_ProductInstallments.Container, props, status === _hooks.GetSimulationStatuses.LOADING && (0, _core.jsx)(_ProductInstallments.Container.Body, null, (0, _core.jsx)(_Loader.Loader, null)), status === _hooks.GetSimulationStatuses.UNEXPECTED_ERROR && (0, _core.jsx)(_ProductInstallments.Container.Body, null, (0, _core.jsx)(_RequestError.RequestError, {
    productType: productType,
    onRetry: refetch,
    error: error
  })), status === _hooks.GetSimulationStatuses.OUT_OF_RANGE_ERROR && (0, _core.jsx)(_ProductInstallments.Container.Body, null, (0, _core.jsx)(_InvalidCreditError.InvalidCreditError, {
    value: intendedCredit,
    productType: productType,
    onEditValue: handleEditClick
  })), simulationLoaded && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_ProductInstallments.Container.Body, null, (0, _core.jsx)(_InstallmentsSelector.InstallmentsSelector, {
    values: installments,
    selectedBy: selectedBy,
    selectedInstallment: selectedInstallment,
    onSelectInstallment: onSelectInstallment
  })), (0, _core.jsx)(_ProductInstallments.Container.Footer, null, (0, _core.jsx)(_ProductInstallments.Button, {
    size: "large",
    onClick: onRequestProposalClick
  }, "Continuar"), (0, _core.jsx)(_typography.Typography, {
    desktop: "sm",
    mobile: "xs",
    weight: "sm",
    color: "fontNeutral60"
  }, "Valores e taxas podem variar ap\xF3s an\xE1lise"))));
};

exports.ProductInstallments = ProductInstallments;
process.env.NODE_ENV !== "production" ? ProductInstallments.propTypes = propTypes : void 0;
ProductInstallments.defaultProps = defaultProps;
ProductInstallments.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProductInstallments",
  "props": {
    "selectedBy": {
      "defaultValue": {
        "value": "OrderBy.MIN",
        "computed": true
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "OrderBy.MIN",
          "computed": true
        }, {
          "value": "OrderBy.MAX",
          "computed": true
        }]
      },
      "required": false,
      "description": ""
    },
    "productType": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onRequestProposalClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "intendedCredit": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};